/**
 * B2：全入口统一上传会话上限（选满 500 可投递；>500 拦截）。
 */
export const MAX_UPLOAD_FILES_PER_SESSION = 500;

/** 单个文件夹读取层上限（与会话上限一致；仅作用于「读文件夹」通道） */
export const MAX_FOLDER_UPLOAD_IMAGES = MAX_UPLOAD_FILES_PER_SESSION;

/**
 * @param {number} incomingCount 本次拟新增文件数
 * @param {number} [currentCount=0] 已在会话/列表中的数量
 * @returns {{ ok: true, nextCount: number } | { ok: false, message: string, nextCount: number }}
 */
export function assertUploadSessionLimit(incomingCount, currentCount = 0) {
  const incoming = Math.max(0, Number(incomingCount) || 0);
  const current = Math.max(0, Number(currentCount) || 0);
  const next = current + incoming;
  if (next > MAX_UPLOAD_FILES_PER_SESSION) {
    return {
      ok: false,
      message: `单次最多上传 ${MAX_UPLOAD_FILES_PER_SESSION} 张图片（当前已选 ${current}，本次 ${incoming}）`,
      nextCount: current,
    };
  }
  return { ok: true, nextCount: next };
}

/** 业务 maxSources 为 null/undefined 时回落到会话上限 */
export function resolveUploadMaxSources(maxSources) {
  if (maxSources == null || maxSources === '') {
    return MAX_UPLOAD_FILES_PER_SESSION;
  }
  const n = Number(maxSources);
  if (!Number.isFinite(n) || n <= 0) {
    return MAX_UPLOAD_FILES_PER_SESSION;
  }
  return Math.min(Math.floor(n), MAX_UPLOAD_FILES_PER_SESSION);
}

export default MAX_UPLOAD_FILES_PER_SESSION;
